import { Image, Container, Row, Col } from 'react-bootstrap';
import "./Services.css"

import W1 from "../Img/Why Us/Network.jpg"
import W2 from "../Img/Why Us/Cost.jpg"
// import W3 from "../Img/Why Us/Expertise.jpg"
import W4 from "../Img/Why Us/Time Saving.jpg"
import W5 from "../Img/Why Us/Solutions.jpg"
import W6 from "../Img/Why Us/Communications.jpg"
import W7 from "../Img/Why Us/Professional Approach.jpg"

function Industries() {
    return (
        <>
            <Image className="fade-in responsive-img" src="https://www.ttspl.in/wp-content/uploads/2025/02/logistics-in-india-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>Industries</strong></h1>
                        <p style={{ fontSize: '20px' }} className='text-center'>Our freight forwarding company provides clients with reliable, cost-effective, and efficient global logistics solutions. We manage the complexities of international shipping so our clients can focus on growing their business with confidence. We are proud of the long-term relationships we’ve built and are happy to provide referrals from satisfied clients who can attest to our professionalism, integrity, and service excellence.</p>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4"><strong>EXTENSIVE NETWORK</strong></h1>
                        <p style={{ fontSize: '20px' }}>Our freight forwarding company has built an extensive network of reliable and trusted carriers, agents, and logistics partners worldwide. This strong global network enables us to provide seamless transportation solutions, competitive freight rates, and dependable delivery services that meet our clients’ shipping and supply chain requirements.</p>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={W1} alt="Network" width="100%" />
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <Image src={W2} alt="Cost" width="100%" />
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4"><strong>COST-EFFECTIVENESS</strong></h1>
                        <p style={{ fontSize: '20px' }}>We leverage our strong network of global carriers, agents, and logistics partners — along with our industry expertise and negotiation capabilities — to secure the most competitive freight rates and optimal routing options for our clients. This ensures cost-effective shipping solutions, improved transit efficiency, and greater overall value compared to managing logistics independently.</p>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4"><strong>OUR EXPERTISE</strong></h1>
                        <p style={{ fontSize: '20px' }}>Our team possesses in-depth expertise in international freight forwarding and global supply chain management, including comprehensive knowledge of shipping regulations, customs procedures, documentation requirements, and multimodal transportation solutions. We closely monitor industry trends, carrier developments, and regulatory changes to ensure efficient and compliant operations. This expertise enables us to deliver reliable, streamlined, and value-driven logistics solutions tailored to our clients’ unique shipping needs.</p>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src="https://psychology.iresearchnet.com/wp-content/uploads/2016/01/Expertise.png" alt="Expertise" width="100%" />
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <Image src={W4} alt="Time" width="100%" />
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4"><strong>TIME-SAVING</strong></h1>
                        <p style={{ fontSize: '20px' }}>Managing international shipping and logistics can be complex and time-consuming, often diverting attention from core business activities. Our team handles the entire freight forwarding process from start to finish — including planning, documentation, customs clearance, carrier coordination, and final delivery — allowing our clients to save time, reduce operational burdens, and focus on growing their business.</p>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4"><strong>FLEXIBLE SOLUTIONS</strong></h1>
                        <p style={{ fontSize: '20px' }}>Our company provides customized logistics solutions tailored to each client’s specific shipping requirements. This includes flexible transportation options, route optimization, budget-focused freight planning, specialized cargo handling, and time-sensitive delivery solutions — all designed to align with our clients’ operational goals and supply chain demands.</p>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={W5} alt="Solutions" width="100%" />
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <Image src={W6} alt="Communication" width="100%" />
                    </Col>
                    <Col md={6} className="p-5">
                        <h1 className="mb-4"><strong>TRANSPARENT COMMUNICATION</strong></h1>
                        <p style={{ fontSize: '20px' }}>We maintain open and transparent communication with our clients throughout the entire shipping process. From booking to final delivery, we provide regular updates, shipment tracking, and proactive notifications to ensure full visibility at every stage. This allows our clients to monitor their cargo in real time, stay informed about transit progress, and operate with complete peace of mind.</p>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row className="d-flex justify-content-center">
                    <Col md={6} className="p-5 justify-text">
                        <h1 className="mb-4"><strong>PROFESSIONAL APPROACH</strong></h1>
                        <p style={{ fontSize: '20px' }}>We have implemented robust systems and streamlined processes to monitor all active shipments, manage documentation, and ensure timely follow-ups at every stage of transit. Our structured operational framework and professional approach enable us to maintain accuracy, efficiency, and complete control over every consignment we handle.</p>
                    </Col>
                    <Col md={6} className="p-5 justify-text">
                        <Image src={W7} alt="Approach" width="100%" />
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Industries